import React from "react";
import {
  TipoDivergenciaComponent,
  TipoDivergenciaComponentProps,
} from "../../TiposDeDivergencias";
import UploadStepTemplate from "../../template/UploadStepTemplate";

import { createBackHandler } from "../../template/utils";
import { MaterialSelectItem } from "../../template/UseGetMateriais";
import QualidadeDoTecidoTrianguladoFinalStep from "../materia-prima/qualidade-do-tecido-triangulado/QualidadeDoTecidoTrianguladoFinalStep";

interface UploadQualidadeProps extends TipoDivergenciaComponentProps {
  payload: { materiais: MaterialSelectItem[]; problemDescription: string };
  onBackComponent: TipoDivergenciaComponent;
}

const UploadQualidadeTecidoTrianguladoStep: TipoDivergenciaComponent<
  UploadQualidadeProps
> = ({ onBack, onSetStep, payload, onBackComponent }) => {
  const stepNumber = "2";
  const stepSubTitle = "Anexar uma imagem para prosseguir.";
  const stepTitle = "A imagem para este tipo de chamado e obrigatória";

  const onBackHandler = createBackHandler(
    onBack,
    onBackComponent || UploadQualidadeTecidoTrianguladoStep
  );
  return (
    <UploadStepTemplate
      header={{ title: stepTitle, subtitle: stepSubTitle, step: stepNumber }}
      nextStepComponent={QualidadeDoTecidoTrianguladoFinalStep as TipoDivergenciaComponent}
      onBack={onBackHandler}
      onSetStep={onSetStep}
      payload={payload}
      onClose={() => { }}
    />
  );
};

export default UploadQualidadeTecidoTrianguladoStep;
